import React from 'react';
import classNames from 'classnames';
import AppBreadcrumb from './AppBreadcrumb';
import { vetor, perfil } from '../';
import { Link } from "react-router-dom";

const AppTopbar = props => {

    const fotoVetor = vetor;
    const fotoPerfil = props.usuario.foto && props.usuario.foto !== "0" ? props.usuario.foto : perfil;

    const notificationsItemClassName = classNames('notifications-item', { 'active-menuitem': props.topbarNotificationMenuActive });
    const profileItemClassName = classNames('profile-item', { 'active-menuitem fadeInDown': props.topbarUserMenuActive });

    function logouf() {
        localStorage.clear();
        window.location.href = props.login;
    }

    return React.createElement(
        'div',
        { className: 'layout-topbar' },
        React.createElement(
            'div',
            { className: 'topbar-left' },
            React.createElement(
                'nav',
                null,
                React.createElement(
                    'button',
                    { type: 'button', className: 'menu-button p-link', onClick: props.onMenuButtonClick },
                    React.createElement('i', { className: 'pi pi-chevron-left' })
                )
            ),
            React.createElement('span', { className: 'topbar-separator' }),
            React.createElement(
                'div',
                { className: 'layout-breadcrumb viewname', style: { textTransform: 'uppercase' } },
                React.createElement(AppBreadcrumb, { routers: props.routers })
            ),
            React.createElement('img', {
                id: 'logo-mobile',
                className: 'mobile-logo',
                src: props.logo,
                alt: 'SmarttIR logo',
                style: { height: "40px !important", width: "84px !important" }
            })
        ),
        React.createElement(
            'div',
            { className: 'topbar-right' },
            React.createElement(
                'ul',
                { className: 'topbar-menu' },
                React.createElement(
                    'li',
                    { className: profileItemClassName },
                    React.createElement(
                        'button',
                        { type: 'button', className: 'p-link', onClick: props.onTopbarUserMenu },
                        React.createElement('img', { src: fotoPerfil, alt: 'diamond-layout', className: 'profile-image' }),
                        React.createElement(
                            'span',
                            { className: 'profile-name' },
                            props.usuario.nome,
                            React.createElement('img', { src: fotoVetor })
                        )
                    ),
                    React.createElement(
                        'ul',
                        { className: 'profile-menu fade-in-up' },
                        React.createElement(
                            'div',
                            null,
                            props.topmenu ? props.topmenu : React.createElement(
                                'span',
                                null,
                                React.createElement(
                                    'li',
                                    null,
                                    React.createElement(
                                        'button',
                                        { onClick: () => logouf(), type: 'button', className: 'p-link' },
                                        'Sair'
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

export default AppTopbar;